<template>
  <div class="grid grid-cols-1 gap-4 p-2 pb-8 md:grid-cols-3">
    <div>
      <h2 class="text-lg font-[500]">{{ $t("settings.auto.informacion_del_usuario") }}</h2>
      <p class="py-4 text-sm">{{ $t("settings.auto.actualiza_la_informacion_de_tu_perfil_y_tu_corre") }}</p>
    </div>
    <div class="flex flex-col gap-4 px-4 pt-4">
      <div class="flex flex-col gap-y-2">
        <label for="dni" class="text-sm">{{ $t("settings.auto.identificacion") }}</label>
        <input
          type="text"
          name="dni"
          class="text-sm rounded-md right-1 focus:ring-blue-400"
          placeholder="000000000"
          v-model="userForm.dni"
          v-bind:class="{
            'ring-red-400': errors.length > 0 && errors.find((e) => e.dni),
          }"
        />

        <p
          class="pl-2 text-xs text-red-400 md:text-sm"
          v-if="errors.length > 0 && errors.find((e) => e.dni)"
        >
          {{ errors.find((e) => e.dni).dni }}
        </p>
      </div>

      <div class="flex flex-col gap-y-2">
        <label for="company_name" class="text-sm">{{ $t("settings.auto.nombre_de_la_compania") }}</label>
        <input
          type="text"
          name="company_name"
          class="text-sm rounded-md right-1 focus:ring-blue-400"
          :placeholder="$t('settings.auto.emanta')"
          v-model="userForm.company_name"
          v-bind:class="{
            'ring-red-400':
              errors.length > 0 && errors.find((e) => e.company_name),
          }"
        />

        <p
          class="pl-2 text-xs text-red-400 md:text-sm"
          v-if="errors.length > 0 && errors.find((e) => e.company_name)"
        >
          {{ errors.find((e) => e.company_name).company_name }}
        </p>
      </div>

      <div class="flex flex-col gap-y-2">
        <label for="assigned_person" class="text-sm"
          >{{ $t("settings.auto.nombre_del_representante") }}</label
        >
        <input
          type="text"
          name="assigned_person"
          class="text-sm rounded-md right-1 focus:ring-blue-400"
          :placeholder="$t('settings.auto.emanta')"
          v-model="userForm.assigned_person"
          v-bind:class="{
            'ring-red-400':
              errors.length > 0 && errors.find((e) => e.assigned_person),
          }"
        />

        <p
          class="pl-2 text-xs text-red-400 md:text-sm"
          v-if="errors.length > 0 && errors.find((e) => e.assigned_person)"
        >
          {{ errors.find((e) => e.assigned_person).assigned_person }}
        </p>
      </div>

      <div class="flex flex-col gap-y-2">
        <label for="email" class="text-sm">{{ $t("settings.auto.correo") }}</label>
        <input
          type="email"
          name="email"
          class="text-sm rounded-md right-1 focus:ring-blue-400"
          placeholder="usuario@emanta.com"
          v-model="userForm.email"
          v-bind:class="{
            'ring-red-400': errors.length > 0 && errors.find((e) => e.email),
          }"
        />

        <p
          class="pl-2 text-xs text-red-400 md:text-sm"
          v-if="errors.length > 0 && errors.find((e) => e.email)"
        >
          {{ errors.find((e) => e.email).email }}
        </p>
      </div>

      <div class="flex flex-col gap-y-2">
        <label for="contact_phone" class="text-sm">{{ $t("settings.auto.telefono") }}</label>
        <PhoneInput
          id="contact_phone"
          v-model="userForm.contact_phone"
          name="contact_phone"
          :invalid="
            errors.length > 0 && Boolean(errors.find((e) => e.contact_phone))
          "
          :disabled="showDetails"
        />
        <p
          class="pl-2 text-xs text-red-400 md:text-sm"
          v-if="errors.length > 0 && errors.find((e) => e.contact_phone)"
        >
          {{ errors.find((e) => e.contact_phone).contact_phone }}
        </p>
      </div>

      <div class="flex flex-col gap-y-2">
        <label for="country" class="text-sm">{{ $t("settings.auto.pais") }}</label>
        <select
          name="country"
          class="text-sm rounded-md right-1 focus:ring-blue-400"
          v-model="userForm.country"
          v-bind:class="{
            'ring-red-400': errors.length > 0 && errors.find((e) => e.country),
          }"
        >
          <option value="">{{ $t("settings.auto.seleccione_el_pais") }}</option>
          <option value="CR">{{ $t("settings.auto.costa_rica") }}</option>
          <option value="MX">{{ $t("settings.auto.mexico") }}</option>
          <option value="US">{{ $t("settings.auto.estados_unidos") }}</option>
        </select>
        <p
          class="pl-2 text-xs text-red-400 md:text-sm"
          v-if="errors.length > 0 && errors.find((e) => e.country)"
        >
          {{ errors.find((e) => e.country).country }}
        </p>
      </div>

      <div class="flex flex-col gap-y-2">
        <label for="preferred_language" class="text-sm">{{ $t("settings.auto.idioma_de_la_app_y_correos") }}</label>
        <select
          name="preferred_language"
          class="text-sm rounded-md right-1 focus:ring-blue-400"
          v-model="userForm.preferred_language"
        >
          <option
            v-for="language in utilityEmailLanguageOptions"
            :key="language.value"
            :value="language.value"
          >
            {{ language.label }}
          </option>
        </select>
      </div>
    </div>
    <div class="flex items-end px-4 mt-auto">
      <button
        type="button"
        class="bg-green-500 text-white px-2 py-1.5 text-sm rounded-md mb-2"
        @click="updateUserInfo()"
      >
        <span class="animate animate-bouncing" v-if="loading"
          >{{ $t("settings.auto.actualizando") }}</span
        >
        <span v-else>{{ $t("settings.auto.actualizar") }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import usersRequests from "@/services/admin/users-service";
import { getLoginUserId } from "@/plugins/shared.js";
import { useToast } from "vue-toastification";
import { utilityEmailLanguageOptions } from "@/shared/language/language-preferences";
import PhoneInput from "@/components/ui/PhoneInput.vue";
import { i18n, setAppLocale } from "@/i18n";

export default {
  components: {
    PhoneInput,
  },
  data() {
    return {
      errors: [],
      userForm: {
        dni: "",
        company_name: "",
        assigned_person: "",
        email: "",
        contact_phone: "",
        country: "",
        preferred_language: "es",
      },
      utilityEmailLanguageOptions,
      userId: "",
      toast: useToast(),
      loading: false,
    };
  },
  methods: {
    updateUserInfo() {
      this.loading = true;
      usersRequests
        .update(this.userId, this.userForm)
        .then((response) => {
          let { status } = response;
          if (status == 200) {
            setAppLocale(this.userForm.preferred_language);
            this.toast.success(i18n.global.t("settings.auto.informacion_actualizada_correctamente"));
          }
        })
        .catch((error) => {
          let { statusCode, message } = error.response.data;
          this.toast.error(i18n.global.t("settings.auto.error_al_actualizar_la_informacion_del_usuario"));
          if (statusCode == 400) {
            this.errors = message;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getUserData() {
      usersRequests
        .getOne(this.userId)
        .then((response) => {
          let { status, data } = response;

          if (status == 200) {
            let {
              dni,
              company_name,
              assigned_person,
              email,
              contact_phone,
              country,
              preferred_language,
            } = data;
            this.userForm = {
              dni,
              company_name,
              assigned_person,
              email,
              contact_phone,
              country,
              preferred_language: preferred_language || "es",
            };
          }
        })
        .catch((error) => {
          console.log(error);
          this.toast.error(i18n.global.t("settings.auto.error_al_cargar_la_informacion_del_usuario"));
        });
    },
  },
  mounted() {
    this.userId = getLoginUserId();
    this.getUserData();
  },
};
</script>

<style lang="scss" scoped></style>
